module.exports = __webpack_public_path__ + "img/plugs.7c2f2b05.svg";